import { render, staticRenderFns } from "./ContactProperties.vue?vue&type=template&id=6a81c67b"
import script from "./ContactProperties.vue?vue&type=script&lang=js"
export * from "./ContactProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports